<template>
  <div id="app">
    <div class="container-fluid px-0">
      <page-header/>
      <router-view/>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/Header.vue'
export default {
  name: 'app',
  components: {
    PageHeader
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 0;
  margin-top: 66px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue